import invariant from 'invariant';
import querystring from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getDetailsById(params) {
    let { baseUrl, brandId, country, language, id, options, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getDetailsById()');
    invariant(brandId, 'brandId is a required param of getDetailsById()');
    invariant(country, 'country is a required param of getDetailsById()');
    invariant(language, 'language is a required param of getDetailsById()');
    invariant(id, 'id is a required param of getDetailsById()');
    invariant(clientId, 'clientId is a required param of getDetailsById()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const optionalQuery = options ? `?${querystring.stringify(options)}` : '';

    const concatUrl = `${baseUrl}search/resources/store/${localisedBrand}/productview/byId/${id}${optionalQuery}`;
    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getDetailsById');
}
